import { InjectionToken } from '@angular/core';

/** Methods ApiService calls on RestaurantDetailsService without importing that class. */
export interface RestaurantDetailsHandle {
  invalidate(restaurantId?: string): void;
  invalidateForCurrentRestaurant(): void;
  getRestaurantDetails(param: any, forceRefresh?: boolean): any;
}

export const RESTAURANT_DETAILS_SERVICE = new InjectionToken<RestaurantDetailsHandle>(
  'RestaurantDetailsService',
);
